import { useContext, useEffect, useState } from "react";
import { LayoutAnimation, StyleSheet, Text, View } from "react-native";
import MaskInput, { Masks, createNumberMask } from "react-native-mask-input";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import IconButton from "../../components/ButtonIcon";
import PageTitle from "../../components/PageTitle";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { AuthContext } from "../../contexts/auth";
import { GlobalContext } from "../../contexts/global";
import { formatMoneyBRL } from "../../helpers/util";
import Validade from "../../helpers/validate";
import { TransferCoins } from "../../services/Api/coin";
import { GetUserByDocument } from "../../services/Api/user";
import { Fonts } from "../../styles";
import * as Colors from "../../styles/colors";
import OptionUser from "./components/OptionUser";
import { IS_WEB } from "@services/Config";

export default function WalletShared({ navigation, route }) {
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [valueTransfer, setValueTransfer] = useState("0.00");
  const [userInfo, setUserInfo] = useState(null);
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [validCpfCnpj, setValidCpfCnpj] = useState({
    isValid: true,
    invalidMessage: "Digite um CPF/CNPJ válido",
  });
  const { emailUser } = useContext(AuthContext);
  const params = route.params;
  const walletBalance = params.wallet.value
  useEffect(() => {
    if (!!cpfCnpj) {
      if (cpfCnpj.length == 11) {
        if (!Validade.validDocument(cpfCnpj.trim())) {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: false });
          setUserInfo(null);
        } else {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: true });
          getUserIdByDocument(cpfCnpj);
        }
      } else if (cpfCnpj.length == 14) {
        if (!Validade.CNPJ(cpfCnpj.trim())) {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: false });
          setUserInfo(null);
        } else {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: true });
          getUserIdByDocument(cpfCnpj);
        }
      }
    } else {
      setUserInfo(null);
    }
  }, [cpfCnpj]);

  LayoutAnimation.linear()

  const getUserIdByDocument = (document) => {
    GetUserByDocument(document)
      .then((value) => {
        if (value.data.email == emailUser) {
          setShowAlert({
            type: "warning",
            title: "Atenção",
            message: "Não pode adicionar a conta atual para compartilhar",
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ show: false });
            },
          });
        } else {
          setUserInfo(value.data);
        }
      })
      .catch((error) => {
        setUserInfo(null);
        setShowAlert({
          type: "warning",
          title: "Não foi possível recuperar o documento",
          message: error.erro ? error.erro : "Não informado",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ show: false });
          },
        });
      });
  };

  const transferCreditHandler = (userId) => {
    let valid = true
    if (!userId) {
      setShowAlert({
        type: "warning",
        title: "Atenção",
        message: "Usuário não encontrado\nverifique o CPF/CNPJ",
        show: true,
        confirmText: "OK",
        pressConfirm: () => { setShowAlert({ ...showAlert, show: false }) }
      })
      valid = false
    }
    else if (!valueTransfer) {
      setLoading({ show: true, message: "Transferindo" });
      setShowAlert({
        type: "warning",
        title: "Atenção",
        message: "Digite um valor válido a ser transferido",
        show: true,
        confirmText: "OK",
        pressConfirm: () => { setShowAlert({ ...showAlert, show: false }) }
      })
      valid = false
    } else if ((valueTransfer / 100) > walletBalance) {
      setShowAlert({
        type: "warning",
        title: "Atenção",
        message: "Você não tem saldo disponivel para transferir",
        show: true,
        confirmText: "OK",
        pressConfirm: () => { setShowAlert({ ...showAlert, show: false }) }
      })
      valid = false
    }
    let valueToTransfer = valueTransfer / 100
    if (valid) {
      setShowAlert({
        type: "info",
        title: "Atenção",
        message: `Confirma transferencia de ${formatMoneyBRL(valueToTransfer)}\npara o usuário ${userId.name}?`,
        show: true,
        confirmText: "Sim",
        cancelText: "Não",
        pressCancel: () => {
          setShowAlert({ ...showAlert, show: false })
        },
        pressConfirm: () => {
          setLoading({ show: true, message: "Transferindo" });
          transferCoins(userId.id, valueToTransfer)
          setShowAlert({ ...showAlert, show: false })
        }
      })
    };

    const transferCoins = (userId, value) => {
      TransferCoins(userId, value).then((value) =>
        setShowAlert({
          type: "success",
          title: "Sucesso",
          message: "Valor transferido",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            navigation.goBack()
            setShowAlert({ ...showAlert, show: false })
          }
        })
      ).catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Ooops",
          message: error.erro ? error.erro : "Não foi possível transferir",
          show: true,
          confirmText: "OK",
          pressCancel: () => { },
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        })
      }).finally(() => {
        setLoading({ show: false, message: "" });
      })
    }
  }

  const brlMask = createNumberMask({
    delimiter: '.',
    separator: ',',
    precision: 2,
  })

  const disableButton = valueTransfer <= 0 
  

  return (
    <PageTitle navigation={navigation} title={"Transferir"} onClickDimmisKeyboard={!IS_WEB}>
      <View style={styles.documentView}>
        <CaixaTextoInputIcone
          iconName={"file-document-outline"}
          placeholderInput={"CPF ou CNPJ"}
          keyboardType={"numeric"}
          onChangeTextInput={(cpfmask, cpf) => setCpfCnpj(cpf)}
          maskInput={Masks.BRL_CPF_CNPJ}
          value={cpfCnpj}
          textContentType="none"
          {...validCpfCnpj}
          styleBox={{ width: "100%", marginBottom: 8 }}
        />
        {!!userInfo ? (
          <OptionUser
            title={userInfo.name}
            subtitle={userInfo.email}
          />
        ) : null}
        <View style={styles.trasnferValueView}>
          <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <Icon name={"currency-usd"} size={48} color={Colors.BLACK} />
            <MaskInput
              mask={brlMask}
              style={styles.transferValueText}
              onChangeText={(value, unmasked) => {
                let valueTransfer = unmasked
                if(valueTransfer.length < 3 ){
                  valueTransfer = unmasked.padStart(3, "0")
                } else if(valueTransfer.substring(0,1) == "0"){
                  valueTransfer = valueTransfer.slice(1)
                }
                setValueTransfer(valueTransfer)
              }
              }
              value={valueTransfer}
              placeholder={"0,00"}
              keyboardType={"numeric"}
              placeholderTextColor={Colors.GRAY_DARK} />
          </View>
          <Text style={styles.balanceActualText}>{`Seu balanço: ${formatMoneyBRL(walletBalance)} disponível`}</Text>
        </View>
        <IconButton
          estilo={{ backgroundColor: disableButton ? Colors.GRAY_DARK : Colors.SUCCESS, width: "100%" }}
          iconName={"currency-usd"}
          textoBotao={"Transferir"}
          onPress={() => transferCreditHandler(userInfo)}
          disabled={disableButton} />
      </View>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  documentView: {
    marginTop: 8,
  },
  userInfoView: {
    paddingHorizontal: 8,
  },
  transferValueText: {
    fontSize: 48,
    fontWeight: "500",
    borderBottomWidth: 1,
    flex: 1,
  },
  trasnferValueView: {
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 8,
    width: "100%"
  },
  balanceActualText: {
    marginVertical: 8,
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.GRAY_DARK
  }
});
